import { supabase } from './supabase';
import type { Database } from '../types/database.types';

export type AffirmationType = Database['public']['Tables']['affirmation_types']['Row'];
export type NewAffirmationType = Database['public']['Tables']['affirmation_types']['Insert'];

export async function listAffirmationTypes() {
  const { data, error } = await supabase
    .from('affirmation_types')
    .select('*')
    .order('name', { ascending: true });

  if (error) throw error;
  return data || [];
}

export async function createAffirmationType(payload: NewAffirmationType) {
  const { data, error } = await supabase
    .from('affirmation_types')
    .insert(payload)
    .select()
    .single();

  if (error) throw error;
  return data;
}

export async function updateAffirmationType(id: string, payload: Partial<NewAffirmationType>) {
  const { data, error } = await supabase
    .from('affirmation_types')
    .update(payload)
    .eq('id', id)
    .select()
    .single();

  if (error) throw error;
  return data;
}

export async function deleteAffirmationType(id: string) {
  const { error } = await supabase
    .from('affirmation_types')
    .delete()
    .eq('id', id);

  if (error) throw error;
}
